import getContextHook from '../contexts/getContextHook';
import { MessagesStateContext } from '../contexts/Messages';

export default getContextHook(MessagesStateContext);
